import { Button } from '@design-system/atoms/button';
import { Link } from '@design-system/atoms/link';
import { Typography } from '@design-system/atoms/typography';
import styled from '@emotion/styled';

export const AuthContainer = styled.div<{ fixedHeight?: number }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* Add height to ensure the container takes up available space if useFixedHeight is true */
  height: ${({ fixedHeight }) => (fixedHeight ? `${fixedHeight}px` : 'auto')};
`;

export const RecoverLink = styled(Link)`
  font-weight: 500;
`;

export const ForgotPasswordContainer = styled(Typography)`
  text-align: center;
`;

export const AuthButton = styled(Button)`
  width: 100%;
`;

export const AuthHeader = styled(Typography)`
  font-size: 32px;
  font-weight: 900;
  color: ${({ theme }) => theme.colors.technical.adaptive};
  margin-bottom: 0;
`;

export const AuthSubHeader = styled(Typography)`
  margin-top: -12px;
  color: ${({ theme }) => theme.colors.technical.gray[60]};
`;

export const AuthHeaderGreen = styled(Typography)`
  display: block;
  color: ${({ theme }) => theme.colors.primary.normal};
`;

export const AuthError = styled(Typography)`
  color: ${({ theme }) => theme.colors.status.error.normal};
  margin: 0;
`;

export const BackupSpace = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  min-height: 0;
`;

export const ResetPasswordImage = styled.img`
  max-width: 375px;
  height: auto;
  margin-bottom: 8px;
`;
